<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'App',
})
</script>
<template>
  <ConfigProvider :locale="zhCN">
    <RouterView />
    <template #renderEmpty><Empty /></template>
  </ConfigProvider>
</template>
<script setup lang="ts" name="App">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { ConfigProvider } from 'ant-design-vue'
import { Empty } from '-/Common/Empty'
</script>
